import { ChangeDetectionStrategy, Component, HostListener, inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import {
  AuthRedirectService,
  AuthService,
  AuthStorageService,
  GlobalMessageService,
  GlobalMessageType,
  SemanticPathService,
} from '@spartacus/core';
import { OutletPosition } from '@spartacus/storefront';
import { combineLatest, Subscription, take } from 'rxjs';
import {
  COUNTRY_CONTEXT_ID,
  CURRENCY_CONTEXT_ID,
  LANGUAGE_CONTEXT_ID,
} from './customcomponents/site-context-selector/context-ids';
import { StatePersistenceService } from './customcomponents/site-context-selector/state-persistence.service';
import { CategoryPageService } from './customServices/category-page.service';
import { CookieService } from './customServices/cookie.service';
import { CountrySelectorService } from './customServices/country-selector.service';
import { ForgotPasswordService } from './services/feature/forgot-pwd/forgot-password.service';
import { NavigationDeleteService } from './services/feature/ScrollBarService/scroll-service.service';
import { KbCurrencyService } from './services/sapSpartacus/kbCurrencyService/kbCurrency-service.service';
import { KbLoadingService } from './services/sapSpartacus/loading.service';
import { Meta } from '@angular/platform-browser';
import { KbAsmService } from './services/feature/kb-asm/store/service/kb-asm.service';
import { KbUpdateProfileService } from './services/feature/update-profile/kb-update-profile.service';
import { isPlatformBrowser } from '@angular/common';
import { WebtrekkConfigService } from './webtrekk-config.service';
import { CustomerIdService } from './services/feature/customerId/customer-id.service';
import { SessionMessageStorageService } from './services/feature/session-message/kb-session-message.service';
import { debounceTime, distinctUntilChanged, distinctUntilKeyChanged, filter, first, map, tap } from 'rxjs/operators';
import { ApplicationRef } from '@angular/core';
import { AsmAuthStorageService, TokenTarget } from '@spartacus/asm/root'
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AppComponent {
  private sessionMessageStorageService = inject(SessionMessageStorageService);
  isLoggedIn: boolean;
  avoidCall: boolean = true;
  isCookieSet: boolean;
  iscustomerIdCookieSet: boolean;
  before: OutletPosition = OutletPosition.BEFORE;
  categoryModel: any;
  loading$ = this.loadingService.loadingSub$;
  subscription = new Subscription();
  private previousUrl: string | null = null;
  private currentUrl: string | null = null;
  private timeout?: ReturnType<typeof setTimeout> | null = null;// Store the timeout ID
  @HostListener('window:popstate', ['$event'])
  onPopState(event: Event): void {
    if (event) {
      this.removeGlobalErrorMessages();
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: Event): void {
    if (event) {
      this.removeGlobalErrorMessages();
    }
  }
  platformId = inject(PLATFORM_ID);
  private asmAlreadyProcessed = false;
  constructor(
    private router: Router,
    private statePersistenceService: StatePersistenceService,
    private cookieService: CookieService,
    private forgotService: ForgotPasswordService,
    private authStorageService: AuthStorageService,
    private CategoryService: CategoryPageService,
    private authService: AuthService,
    private loadingService: KbLoadingService,
    private clickService: NavigationDeleteService,
    private globalmsgService: GlobalMessageService,
    private countrySelectorService: CountrySelectorService,
    private kbCurrencyService: KbCurrencyService,
    private kbAsmService: KbAsmService,
    private activatedRoute: ActivatedRoute,
    private meta: Meta,
    private renderer: Renderer2,
    private closeAccService: KbUpdateProfileService,
    private authRedirectService: AuthRedirectService,
    private semanticPathService: SemanticPathService,
    private webtrekkService: WebtrekkConfigService,
    private readonly customerIdService: CustomerIdService,
    private readonly appRef: ApplicationRef,
    private asmAuthStorageService: AsmAuthStorageService
  ) {
    if (isPlatformBrowser(this.platformId)) {
      const oldNavigate = this.router.navigate.bind(this.router);
      this.router.navigate = (...args: any[]) => {
        console.trace('ROUTER NAVIGATE', args);
        return oldNavigate(...args);
      };

      const oldNavigateByUrl = this.router.navigateByUrl.bind(this.router);

      this.router.navigateByUrl = (...args: any[]) => {

        console.trace('ROUTER NAVIGATE BY URL', args);
        return oldNavigateByUrl(...args);
      };
      this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.previousUrl = this.currentUrl;
          this.currentUrl = event.urlAfterRedirects;
        });
    }
  }

  title = 'kbecomstore';

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe((event) => {
          console.log('Navigation detected', event);
          const w = window as any;
          if (w._hsq) {
            w._hsq.push(['trackPageView']);
            console.log('HubSpot trackPageView fired');
          }
        });
    }
    //Check if the cookie is set
    // const isCookieSet = this.cookieService.isCookieSet(`countryIsoCodeNA`);
    if (isPlatformBrowser(this.platformId)) {
      /* ASM logic */
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          console.log(
            'NAVIGATION:',
            event.url,
            '=>',
            event.urlAfterRedirects
          );
        }
      });
      this.validASMSessionorNot();
      /* ASM logic */
      const currentUrl = window.location.href;
      const isCookieSet = this.statePersistenceService.readStateFromStorage({ key: COUNTRY_CONTEXT_ID });
      this.webtrekkService.initWebtrekk();
      if (!isCookieSet && !currentUrl.includes('/cookies')) {
        this.router.navigate(['/countrySelectorPage']);
      }
      this.authService.isUserLoggedIn().subscribe((data) => {
        this.isLoggedIn = data;
        console.log('LOGIN STATE', data);
      });
      this.authStorageService.getToken().subscribe((x) => {
        if (x.access_token == undefined && !this.isLoggedIn && this.avoidCall) {
          this.rememberMe();
        }
      });

      //To Display the catgory title
      this.CategoryService.categoryData.subscribe((x) => {
        this.categoryModel = x;
      });
      this.subscription.add(this.clickService.click$.subscribe((event) => {
        if (event) {
          this.removeGlobalErrorMessages();
        }
      }));
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.removeGlobalErrorMessages();
          this.addLoginGlobalErrorMessageFromStorage();
        }
      });
      this.checkRouteHasAccess();

      this.checkCoreRouteAccess();
      this.forgotService.canSetNEwCountry$.subscribe((can) => {
        if (can) {
          this.setNewCountry();
        }
      });
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd),
        debounceTime(300),
        take(1)
      ).subscribe(() => {
        setTimeout(() => {
          this.handleQueryParams();
        }, 5000);
      });

      this.showAccClosedSuccessMsg();


      //to add meta tag
      /*  if (currentUrl.includes('/qa') || currentUrl.includes('/dev')) {
         this.meta.addTag({ name: 'robots', content: 'noindex,nofollow' });
       }
       else {
         this.meta.addTag({ name: 'robots', content: 'index,follow' });
       } */
      this.addLoginGlobalErrorMessage();
      // if (currentUrl.includes('/qa.')) {
      //   this.meta.addTag({ name: 'google-site-verification', content: 'n9TTKpfLkk6vt_N_GsFezWUNRGY49FAuxpq3Mk_Es4k' });
      // }

      this.router.events
        .pipe(filter(e => e instanceof NavigationEnd))
        .subscribe((e: any) => {
          console.log('ROUTE CHANGED', e.urlAfterRedirects);
        });
    }
  }
  validASMSessionorNot() {
    this.asmAuthStorageService.getTokenTarget()
      .pipe(
        filter(target => target !== undefined), // ✅ wait until available
        take(1)
      )
      .subscribe(target => {

        const emulatedToken = this.asmAuthStorageService.getEmulatedUserToken();

        const isAgent = target === TokenTarget.CSAgent;
        const isEmulated = !!emulatedToken;

        console.log(' FINAL ASM Check:', { target, isEmulated });

        if (!isAgent && !isEmulated) {
          console.log('Removing stale ASM flag');

          localStorage.removeItem('asm_enabled');
          localStorage.removeItem('spartacus⚿⚿asm');
          sessionStorage.removeItem('asm_enabled');   // ✅ ADD THIS
          sessionStorage.removeItem('spartacus⚿⚿asm'); // ✅ ADD THIS
          localStorage.removeItem('ASM_ENABLED_LOCAL_STORAGE_KEY');

          sessionStorage.removeItem('ASM_ENABLED_LOCAL_STORAGE_KEY');
          const asmElement = document.querySelector('app-kb-asm-main-ui');
          if (asmElement) {
            (asmElement as HTMLElement).style.display = 'none';
          }
        }

      });
  }
  private handleQueryParams() {
    this.activatedRoute.queryParamMap
      .pipe(
        map((params): { uid: string | null } => ({
          uid: params.get('uid')
        })),
        distinctUntilChanged(
          (prev, curr) => prev.uid === curr.uid,
        ),
      )
      .subscribe(({ uid }) => {
        // ✅ ASM LOGIN
        if (uid && uid !== 'undefined' && !this.asmAlreadyProcessed) {
          this.asmAlreadyProcessed = true;
          const userKey = encodeURIComponent(uid);
          console.log('✅ Dispatching ASM SSO:', userKey);
          this.kbAsmService.loginWithASMSSO(userKey);
        }

      });
  }
  //need to call Remember my login while user enters website
  rememberMe() {
    console.log('REMEMBER ME CALLED');
    console.log('REMEMBER ME CALLED');
    console.log('CURRENT WINDOW URL', window.location.href)
    console.log('CURRENT ROUTER URL', this.router.url);
    const rememberMe = `kbecomstorefrontRememberMeNA`;
    this.isCookieSet = this.cookieService.isCookieSet(rememberMe);
    this.iscustomerIdCookieSet = this.cookieService.isCookieSet('customerIdNA');
    if (this.isCookieSet) {
      const refToken = this.forgotService.getRefreshToken();
      const payload = {
        refresh_token: refToken,
      };
      this.forgotService.renewToken(payload).subscribe((res) => {
        if (res) {
          this.avoidCall = false;
        }
        this.forgotService.setRefreshToken(res.refresh_token);
        this.forgotService.storeNewAccessToken(res.access_token);
      });
    } else {
      this.avoidCall = true;
      this.forgotService.deleteRefreshTokenCookie();
    }
  }

  ngAfterContentChecked() {
    if ((this.isCookieSet && !this.isLoggedIn) || (this.iscustomerIdCookieSet && !this.isLoggedIn)) {
      this.forgotService.deleteRefreshTokenCookie();
    }
  }
  ngOnDestroy(): void {
    // Unsubscribe from the scroll event
    if (this.subscription && this.subscription instanceof Subscription) {
      this.subscription.unsubscribe();
    }


    if (this.timeout) {
      clearTimeout(this.timeout);
    }

  }

  removeGlobalErrorMessages() {
    if (this.router.url.includes('/login')) {
      return;
    }

    this.globalmsgService.remove(GlobalMessageType.MSG_TYPE_ERROR);
    this.globalmsgService.remove(GlobalMessageType.MSG_TYPE_INFO);
    this.globalmsgService.remove(GlobalMessageType.MSG_TYPE_CONFIRMATION);
    this.globalmsgService.remove(GlobalMessageType.MSG_TYPE_WARNING);
    this.globalmsgService.remove(GlobalMessageType.MSG_TYPE_ASSISTIVE);

  }


  setNewCountry() {
    const countryIsoCode = this.statePersistenceService.readStateFromStorage({ key: COUNTRY_CONTEXT_ID }) as string;
    if (countryIsoCode) {
      // let countryIsoCode = this.cookieService.getCookieValue('countryIsoCodeNA');
      this.countrySelectorService.getDataForCountry(countryIsoCode).subscribe((data) => {
        this.countrySelectorService.setMediaUrl(data.mediaUrl);
        this.countrySelectorService.setDisplayIsoCode(data.displayIsoCodes);
        this.countrySelectorService.setLangIsoCode(data.langIsoCodes);
      });
    }
  }

  stateonmultipleTab() {
    const countryIsoCode = this.statePersistenceService.readStateFromStorage({ key: COUNTRY_CONTEXT_ID }) as string;
    const langIsoCode = this.statePersistenceService.readStateFromStorage({ key: LANGUAGE_CONTEXT_ID }) as string;
    const currencyIsoCode = this.statePersistenceService.readStateFromStorage({ key: CURRENCY_CONTEXT_ID }) as string;
    //get data fRom Cookies
    const cookie_countryIsoCode = this.cookieService.getCookieValue('countryIsoCodeNA');
    const cookie_langIsoCode = this.cookieService.getCookieValue('displayIsoCodeNA');
    const cookie_currencyIsoCode = this.cookieService.getCookieValue('defaultCurrencyNA');
    if (
      countryIsoCode == cookie_countryIsoCode &&
      langIsoCode == cookie_langIsoCode &&
      currencyIsoCode == cookie_currencyIsoCode
    ) {
      return;
    } else {
      this.kbCurrencyService.setAllThree(cookie_countryIsoCode, cookie_langIsoCode, cookie_currencyIsoCode);
    }
  }

  ngAfterViewInit(): void {
    this.timeout = setTimeout(() => {
      if (isPlatformBrowser(this.platformId)) {
        const contentElement = document.querySelector('#onetrust-pc-sdk');
        if (contentElement) {
          const cookieLink = contentElement.querySelector('.cookie-details-link');
          const privacyLink = contentElement.querySelector('.privacy-notice-link');

          if (cookieLink) {
            this.renderer.setAttribute(cookieLink, 'href', '/cookies');
          }

          if (privacyLink) {
            this.renderer.setAttribute(
              privacyLink,
              'href',
              'https://www.bendix.com/en/meta/footer/privacy-policy/'
            );
          }
        }
      }
    }, 2500);

    if (isPlatformBrowser(this.platformId)) {
      const observer = new MutationObserver(() => {
        const divs = document.querySelectorAll('body > div');

        divs.forEach((el: any, index: number) => {
          const prevEl = divs[index - 1];

          if (
            prevEl &&
            prevEl.classList.contains('cdk-overlay-container') &&  // ✅ your condition
            el.style &&
            el.style.zIndex === '2000000000' &&
            !el.classList.contains('captcha-custom')
          ) {
            el.classList.add('captcha-custom');
          }
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

  }
  showAccClosedSuccessMsg() {
    this.closeAccService.accClosed.subscribe((accClosed: boolean) => {
      if (accClosed) {
        this.timeout = setTimeout(() => {
          this.globalmsgService.add({ key: this.closeAccService.message }, GlobalMessageType.MSG_TYPE_ERROR);
        }, 200);
      }
    });
  }
  checkRouteHasAccess() {
    this.subscription.add(
      combineLatest([this.authService.isUserLoggedIn(), this.router.events])
        .pipe(
          filter(([isLoggedIn, event]) => !isLoggedIn && event instanceof NavigationEnd && event.url.includes('/cart')),
          tap(() => {
            this.authRedirectService.saveCurrentNavigationUrl();
            this.router.navigate([this.semanticPathService.get('login') ?? '']);
          })
        )
        .subscribe()
    );
  }
  checkCoreRouteAccess() {
    this.subscription.add(
      combineLatest([
        this.authService.isUserLoggedIn(),
        this.router.events.pipe(filter(event => event instanceof NavigationEnd))
      ])
        .pipe(
          tap(([isLoggedIn, event]: [boolean, NavigationEnd]) => {
            const url = event.urlAfterRedirects;

            const isCoreRoute =
              url.includes('/kbCoreSubmissionPage') ||
              url.includes('/kbCoreReportsPage') ||
              url.includes('/search-coreReturn');

            if (!isCoreRoute) {
              return;
            }


            if (!isLoggedIn) {
              this.authRedirectService.saveCurrentNavigationUrl();
              this.router.navigate([
                this.semanticPathService.get('login') ?? ''
              ]);
              return;
            }
            this.customerIdService.getAllCustomerId().pipe(take(1)).subscribe(
              (apiResponse: any) => {
                const userData = apiResponse?.userWS;


                const isSubmissionUser = !!userData?.isCoreSubmissionGroup;
                const isSearchUser = !!userData?.isCoreSearchGroup;

                let hasAccess = false;

                if (url.includes('/kbCoreSubmissionPage') || url.includes('/search-coreReturn')) {
                  hasAccess = isSubmissionUser;
                }
                else if (url.includes('/kbCoreReportsPage')) {
                  hasAccess = isSearchUser;
                }

                if (!hasAccess) {
                  this.router.navigate(['/CoreInfoCenter']);
                }
              }
            );
          })
        )
        .subscribe()
    );
  }
  private addLoginGlobalErrorMessage() {
    const message = this.sessionMessageStorageService.getMessage();

    if (message) {
      setTimeout(() => this.globalmsgService.add({ key: message.message }, GlobalMessageType.MSG_TYPE_ERROR));
    }
  }
  private addLoginGlobalErrorMessageFromStorage() {
    const message = this.sessionMessageStorageService.getMessageFromStorage();

    console.log('Retrieved Message:', message);

    if (message) {
      this.globalmsgService.add(
        { key: message.message },
        message.type
      );

      this.sessionMessageStorageService.clearMessage();
    }
  }
}
